import {
    ILandingElement,
    IUserFlow,
} from '@/interfaces';
import { FlowsState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setFlows(state: FlowsState, payload: IUserFlow[]) {
        state.flows = payload;
    },
    setLandingElements(state: FlowsState, payload: ILandingElement[]) {
        state.landingElements = payload;
    },
    setCanAddElements(state: FlowsState, payload: boolean) {
        state.canAddElements = payload;
    },
};

const {commit} = getStoreAccessors<FlowsState | any, State>('');

export const commitSetFlows = commit(mutations.setFlows);
export const commitSetLandingElements = commit(mutations.setLandingElements);
export const commitSetCanAddElements = commit(mutations.setCanAddElements);
